import { useState } from 'react';
import { Card } from './Card';

export function MusicPlayer() {
    const [isPlaying, setIsPlaying] = useState(false);

    return (
        <Card variant="pop" className="!p-0 !rounded-full overflow-hidden flex items-center pr-4 shadow-[4px_4px_0_0_#000] hover:scale-105 transition-transform">
            <div className="w-14 h-14 bg-zinc-900 flex items-center justify-center shrink-0">
                {/* Visualizer bars */}
                <div className="flex gap-1 items-end h-6">
                    <div className={`w-1 bg-primary h-3 ${isPlaying ? 'animate-pulse' : ''}`} />
                    <div className={`w-1 bg-secondary h-5 ${isPlaying ? 'animate-pulse' : ''}`} style={{ animationDelay: '100ms' }} />
                    <div className={`w-1 bg-accent h-4 ${isPlaying ? 'animate-pulse' : ''}`} style={{ animationDelay: '200ms' }} />
                    <div className={`w-1 bg-white h-2 ${isPlaying ? 'animate-pulse' : ''}`} style={{ animationDelay: '75ms' }} />
                </div>
            </div>

            <div className="ml-3 flex-1 min-w-0">
                <div className="text-[10px] font-bold text-zinc-400 uppercase tracking-widest">Now Playing</div>
                <div className="text-sm font-bold text-zinc-900 truncate">PASTEL REVERIE ...</div>
            </div>

            <button
                onClick={() => setIsPlaying(!isPlaying)}
                className="ml-4 w-8 h-8 rounded-full border-2 border-zinc-900 flex items-center justify-center hover:bg-zinc-100"
            >
                {isPlaying ? (
                    <div className="flex gap-1">
                        <div className="w-1 h-3 bg-zinc-900" />
                        <div className="w-1 h-3 bg-zinc-900" />
                    </div>
                ) : (
                    <div className="w-0 h-0 border-l-[8px] border-l-zinc-900 border-y-[5px] border-y-transparent ml-0.5" />
                )}
            </button>
        </Card>
    );
}
